import React from 'react';
import './shared/flowPlannerShared.css';

/**
 * Section header for the Flow Planner results: cycle picker on the left,
 * TPH KPI block on the right.
 *
 * Cycle picker uses underline tabs — communicates "navigation between
 * datasets" rather than "settings toggle" (the segmented control pattern
 * used by View toggles elsewhere in the section).
 */
const CycleHeader = ({ cycles, selectedCycle, onSelect, displayName, tph, actions = null }) => (
  <div className="fp-theme">
    <div className="fp-cycle-header">
      <div className="fp-cycle-tabs" role="tablist">
        {cycles.map((c) => (
          <button
            key={c}
            type="button"
            role="tab"
            aria-selected={c === selectedCycle}
            onClick={() => onSelect(c)}
            className="fp-cycle-tab">
            {displayName(c)}
          </button>
        ))}
      </div>
      {actions && <div className="fp-cycle-actions">{actions}</div>}
      <div className="fp-cycle-kpi">
        <span className="fp-cycle-kpi-value">{(tph || 0).toLocaleString()}</span>
        <span className="fp-cycle-kpi-label">TPH · Current Cycle</span>
      </div>
    </div>
  </div>
);

export default CycleHeader;
